import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import { BOLD_FONT_WEIGHT, LG_PADDING, SM_FONT_SIZE, XL_FONT_SIZE } from '../../components/Common/StyleElement';

export const Word2vecSearchRow = styled(Row)`
    padding-bottom: ${LG_PADDING};
`

export const Word2vecTextbox = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    color: #333;
    cursor: default;
`

export const Word2vecTextboxTitle = styled.p`
    padding-bottom: 0.5rem;
`

export const Word2vecTextboxInput = styled.input`
    margin-bottom: 10px;
    line-height: 1.5;
    font-size: 1rem;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    box-sizing: border-box;
    cursor: default;
    outline: none;
    padding: 8px 52px 8px 10px;
    transition: all 200ms ease;
    width: 100%;
`
export const Word2vecIntermediateBox = styled.div`
    width: 100%;
    height: 520px;
    border-radius: 15px;
    padding: 2rem;
    overflow-y: auto;
    box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.5s ease-in-out;

`
// export const Word2vecIntermediateBox = styled.div`
//     width: 100%;
//     height: 520px;
//     border-radius: 15px;
//     padding: 2rem;
//     overflow-y: auto;
//     box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//     transition: all 0.5s ease-in-out;
//     ${props => !props.disabled ?
//     `box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//         background-color: #fff;
//         `
//     :
//     `background-color: #EEEEEE;
//         color: #ABABAB;
//         cursor: pointer;
//         &:hover {
//             box-shadow: 4px 6px 15px rgba(0, 0, 0, 0.2);
//             transform: scale(0.98);
//         }
//         `
//     }
// `

export const Word2vecIntermediateTitle = styled.div`
    font-weight: ${BOLD_FONT_WEIGHT};
    text-transform: uppercase;
    margin-bottom: 2rem;
    font-size: ${XL_FONT_SIZE};
    text-align: center;
`

export const Word2vecIntermediateText = styled.p`
    font-size: ${SM_FONT_SIZE};
`

